(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/all-admin-checkbox.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/all-admin-checkbox.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const Checkbox = svs.ui.reactForm.Checkbox;
const _svs$arena$pages$team = svs.arena.pages.teams.dialogs,
  showAllAdminInformationDialog = _svs$arena$pages$team.showAllAdminInformationDialog,
  showTechnicalError = _svs$arena$pages$team.showTechnicalError;
const putAdminWagerSyndicateAsync = svs.arena.service.teamsService.putAdminWagerSyndicateAsync;
const AllAdminCheckbox = _ref => {
  let isAdminManagedWagers = _ref.isAdminManagedWagers,
    teamId = _ref.teamId;
  const _React$useState = React.useState(isAdminManagedWagers),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAdminWager = _React$useState2[0],
    setIsAdminWager = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isCheckboxDisabled = _React$useState4[0],
    setIsCheckboxDisabled = _React$useState4[1];
  const handleClick = async e => {
    e.stopPropagation();
    setIsCheckboxDisabled(true);
    const response = await putAdminWagerSyndicateAsync(teamId, !isAdminWager);
    if (response.error) {
      showTechnicalError();
    } else {
      setIsAdminWager(!isAdminWager);
      const track = {
        category: 'spela-tillsammans',
        action: 'place_bet_all',
        opt_label: !isAdminWager ? 'yes' : 'no'
      };
      svs.components.analytics.trackEvent(track);
    }
    setIsCheckboxDisabled(false);
  };
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between padding-bottom"
  }, React.createElement(Checkbox, {
    checked: !isAdminWager,
    className: "margin-top-1",
    disabled: isCheckboxDisabled,
    onChange: handleClick
  }, "Alla medlemmar kan l\xE4gga spel"), React.createElement(IconButton, {
    className: "align-self-center",
    onClick: e => showAllAdminInformationDialog(e.target),
    size: 300
  }, React.createElement(Icon, {
    icon: "information",
    size: "300"
  })));
};
svs.arena.pages.teams.components.AllAdminCheckbox = AllAdminCheckbox;

 })(window);